import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { HOME_PATH, useLandingResolver } from '../../access';

import { useSignedInUser } from '../../session';
import { useIsViewing } from '../../utilities/customHooks/useIsViewing';
import { analytics } from '../../modules/analytics';
import { useUnifiedDashboardStore } from '../../store/UnifiedDashboardStore';

import { isVatikaUser } from './header.rules';

export interface HeaderActions {
  isViewing: boolean;
  showVatikaLogo: boolean;
}

export const useHeaderActions = (): HeaderActions => {
  const { id, email, name } = useSignedInUser();
  const isViewing = useIsViewing();

  useEffect(() => {
    void analytics.identifyUser({ distinctId: id, userProperties: { email, name } });
  }, [id, email, name]);

  return { isViewing, showVatikaLogo: isVatikaUser(email) };
};

export const useGoToLanding = (): (() => void) => {
  const navigate = useNavigate();
  const landingNow = useLandingResolver();

  return () => {
    useUnifiedDashboardStore.getState().resetUnifiedDashboardStore();
    const landing = landingNow();
    navigate(landing.kind === 'open' ? landing.path : HOME_PATH);
  };
};
